import styled from "styled-components";

export const CarouselStyled = styled.div`
	width: 100%;

	.mySwiper {
		height: inherit;
	}

	&.mobile {
		height: 29em;
	}

	.swiper-wrapper {
		margin-left: 1.2em;
	}
`;
